import { urlWithQueryString } from '@util';

const baseURL = '/payment';

async function clientToken() {
    const res = await axios.get(`${baseURL}/client_token`);
    return res.data.clientToken;
}

async function getPaymentMethodsV2() {
    const res = await axios.get(`${baseURL}/methods-v2`);
    return res.data;
}

async function addPaymentMethodV2(paymentMethod) {
    const res = await axios.post(`${baseURL}/methods-v2`, {
        paymentMethod,
    });
    return res.data;
}

async function checkout({ amount, nonce = null, paymentMethodToken = null }) {
    const res = await axios.post(`${baseURL}/checkout`, {
        amount,
        nonce,
        paymentMethodToken,
    });
    return res.data;
}

async function makeDefaultV2(paymentMethodId) {
    const res = await axios.post(`${baseURL}/default_method-v2`, {
        paymentMethodId,
    });
    return res.data;
}

async function deletePaymentMethodV2(cardId, stopCampaigns) {
    const res = await axios.delete(`${baseURL}/methods-v2`, {
        params: {
            paymentMethodId: cardId,
            stopCampaigns: stopCampaigns ? 1 : 0,
        },
    });
    return res.data;
}

async function createPayment(amount) {
    const res = await axios.post(`${baseURL}`, { amount });
    return res.data;
}

async function executePayment({ payerId, paymentId, amount, campaignId }) {
    const res = await axios.post(`${baseURL}/execute`, {
        payerId,
        paymentId,
        amount,
        campaignId,
    });
    return res.data;
}

async function getSubscription(query = {}) {
    const res = await axios.get(
        urlWithQueryString(`${baseURL}/subscriptions`, query)
    );
    return res.data;
}

function redirectToPortal({ returnUrl }) {
    const URL = `${baseURL}/createCustomerPortalSession`;

    return axios
        .post(URL, {
            returnUrl: returnUrl || window.location.href,
        })
        .then(R.prop('data'));
}

function createCheckoutSession(data = {}) {
    return axios
        .post(`${baseURL}/createCheckoutSession`, data)
        .then(R.prop('data'));
}

function upgradeSubscription(data = {}) {
    return axios.put(`${baseURL}/subscription`, data).then(R.prop('data'));
}

function makePaymentForLiteVersion() {
    return axios
        .put(`${baseURL}/subscription`, { plan: 'LITE' })
        .then(R.prop('data'));
}

function trackPaymentProcess({ path = '', action, type }) {
    // type: "nicepay-lite" ||  "stripe";
    const route = `${baseURL}/slack-analysis/plan-t/${type}`;

    return axios.post(route, { path, action }).then(R.prop('data'));
}

function getSubscriptionV2(query = {}) {
    return axios.get(`${baseURL}/subscriptions/v2`, query).then(R.prop('data'));
}

function cancelSubscription({ subscriptionType }) {
    return axios
        .post(`${baseURL}/subscriptionV2/cancel`, { subscriptionType })
        .then(R.prop('data'));
}

export default {
    clientToken,
    checkout,
    createPayment,
    executePayment,
    getSubscription,
    redirectToPortal,
    createCheckoutSession,
    upgradeSubscription,
    makePaymentForLiteVersion,
    trackPaymentProcess,
    getSubscriptionV2,
    getPaymentMethodsV2,
    addPaymentMethodV2,
    makeDefaultV2,
    deletePaymentMethodV2,
    cancelSubscription,
};
